export const ADMIN_URI_BASE = 'admin'
export const CUSTOMER_URI_BASE = 'customer'

export const GuestRoutes = {
  HOME: 'Home',
  MENU: 'Menu',
  EXPIRED: 'Expired',
  MAINTENANCE: 'Maintenance',
  ABOUT: 'About',
  HELP: 'Help',
  FEEDBACK: 'Feedback',
  NEW_ORDER: 'New Order',
  VERIFY_EMAIL_SUCCESS: 'Email Verification Success',
  VERIFY_EMAIL_EXPIRED: 'Email Verification Expired',
}

export const CustomerRoutes = {
  SIGNUP: 'Signup',
  LOGIN: 'Login',
  LOGIN_WITH_PHONE: 'Login With Phone',
  LOGIN_VERIFY_PHONE: 'Login Verify Phone',
  LOGIN_EMAIL_HINT: 'Login Email',
  FORGOT_PASSWORD: 'Forgot Passord',
  PASSWORD_RESET: 'Password Reset',
  VERIFY_EMAIL: 'Email Verification',
  DASHBOARD: 'Customer Dash',
  LEGACY_UPDATE: 'Legacy Account Update',
  LEGACY_UPDATE_NO_EMAIL: 'Legacy Account Update No Email',
  ACCOUNT_UPDATE: 'Customer Edit',
  ORDERS_INDEX: 'Order History',
  ORDER_VIEW: 'Customer Order',
}

export const MerchantRoutes = {
  LOGIN: 'Admin Login',
  SIGNUP: 'Admin Signup',
  FORGOT_EMAIL: 'Forgot Email',
  Manage: {
    HOME: 'Merchant Home',
    DASHBOARD: 'Dashboard',
    SHOP_SETTINGS: 'Shop Settings',
    ORDERS: 'Manage Orders',
    ORDER_DETAIL: 'Order Detail',
    ORDER_PREP: 'Order Prep',
    PRINT_ORDER: 'Print Order',
    SECTIONS: 'Manage Sections',
    ITEMS: 'Manage Items',
    REARRANGE: 'Rearrange Menu',
    AVAILABILITY: 'Manage Availability',
    CUSTOMERS: 'Manage Customers',
    ACCOUNT: 'Manage Account',
    SUPPORT: 'Merchant Support',
  },
}

export const SuperAdminRoutes = {
  DASHBOARD: 'Super Admin Dashboard',
}

const RouteNames = {
  Guest: GuestRoutes,
  Merchant: MerchantRoutes,
  Customer: CustomerRoutes,
  SuperAdmin: SuperAdminRoutes,
}
export default RouteNames
